import { render, staticRenderFns } from "./ProxyDataReport.vue?vue&type=template&id=3762b120&scoped=true"
import script from "./ProxyDataReport.vue?vue&type=script&lang=js"
export * from "./ProxyDataReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3762b120",
  null
  
)

export default component.exports